
import { Button } from '@leroy-merlin-br/backyard-react-ui'

import { RangeSlider } from 'lmcv/components/RangeSlider'

import WizardStep from '../components/WizardStep'
import * as Ilustrations from '../components/Ilustrations'
import * as S from '../styled'

const WeeksCount = ({
  step,
  errors,
  register,
  hasError,
  prevStep,
  isLoading,
  customerData
}) => {
  const { projectWeeks } = customerData
  const isDisabled = (+projectWeeks <= 0 || +projectWeeks > 12)

  return (
    <WizardStep step={2} currentStep={step}>
      <Ilustrations.Time />
      <S.StepTitle as="h3" size="mega">Adicione um tempo para esse projeto</S.StepTitle>
      <RangeSlider
        name="projectWeeks"
        min={0}
        max={12}
        step={1}
        errors={errors}
        defaultValue={projectWeeks}
        reference={register({ min: 1, max: 12, required: true })}
      />
      <S.ButtonGrid>
        <Button
          type="button"
          size="kilo"
          variant="outline"
          onClick={prevStep}
        >
          Voltar
        </Button>
        <Button
          type="submit"
          size="kilo"
          isLoading={isLoading}
          isDisabled={isDisabled}
        >
          Próxima etapa
        </Button>
        {hasError &&
          <S.ButtonGridError>
          Não possível efetuar o cadastro, por favor tente novamente.
          </S.ButtonGridError>
        }
      </S.ButtonGrid>
    </WizardStep>
  )
}

export default WeeksCount
